import type { Device } from '@studio/models/device';
import type { MultiDeviceSelector } from '../types.js';
import type { StatusDevice } from '@tryiris-ai/common.protojs/agent/v1/agent';
import { StatusDeviceEgress } from '@tryiris-ai/common.protojs/agent/v1/agent';

export const DeviceEgressSelector: MultiDeviceSelector<{
  id: Device['id'];
  name: string;
  egress: StatusDevice['egress'];
  type: 'video' | 'audio';
  videoCodec: string | undefined;
}> = {
  transform: (device) => ({
    id: device.id,
    name: device.studio?.name ?? device.id,
    // Rebuild only the status fields (not a pass-through) so the hook's JSON
    // diffing ignores unrelated egress churn; $type completes the message shape.
    egress: {
      $type: StatusDeviceEgress.$type,
      rtmpStatus: device.status?.egress?.rtmpStatus,
      recordingStatus: device.status?.egress?.recordingStatus,
      ndiOutputStatus: device.status?.egress?.ndiOutputStatus
    },
    type: device.studio?.video?.uri ? 'video' : 'audio',
    // @ts-ignore codec field exists in agent.proto but @tryiris-ai/common.protojs has not been bumped yet (ENG-3463)
    videoCodec: device.status?.video?.status?.codec
  })
};

export type DeviceEgressSelectorType = NonNullable<(typeof DeviceEgressSelector)['direct']>;
